import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["zh", "en"];
import React, { useMemo } from 'react';
import { useAddLocaleEventListener } from "../../hooks/useLocale";

/**
 * 根据当前语言环境自动切换显示不同的组件或元素的组件
 * @function
 * @example
 * <LocaleAutoSwitchHOC
 *    zh={
 *         <p className="mt-3">
 *            <span>{t('qS52RvgddsLH')}</span>
 *         </p>
 *       }
 *    en={
 *         <p className="mt-3">
 *             <span>{t('qZ4AcR9Xvm2a')}</span>
 *         </p>
 *       }
 *  />
 */
var LocaleAutoSwitchHOC = function LocaleAutoSwitchHOC(props) {
  var zh = props.zh,
      en = props.en,
      otherProps = _objectWithoutProperties(props, _excluded);

  var locale = useAddLocaleEventListener();
  var dom = useMemo(function () {
    if (locale === 'zh') {
      return zh;
    } else {
      return props[locale];
    }
  }, [locale, props[locale]]);
  return /*#__PURE__*/React.cloneElement(dom, _objectSpread(_objectSpread({}, otherProps), dom.props));
};

export default LocaleAutoSwitchHOC;